import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/api/user/user.service';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { SnackBarService } from 'src/app/core/services/snackbar/snackbar.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { LoginRequestDTO } from 'src/app/shared/models/dtos/requests/login-request-dto/login-request-dto';
import { RoutesKeys } from 'src/app/utils/routes';
import { TProgramEvaluationData } from '../../molecules/delete-request-program-eval-modal/delete-request-program-eval-modal.component';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Delete account component!
 */
export class DeleteAccountComponent implements OnInit {
  RoutesKeys = RoutesKeys;
  text = {
    deleteAccount: 'delete-account',
    deleteYourAccount: 'delete-your-account',
    deleteAccountInfo: 'delete-account-informative-text',
    emailAddress: 'email-address',
    password: 'password',
    forgotPassword: 'forgot-your-password',
    deleteMyAccount: 'delete-my-account',
    changedMyMind: 'i-changed-my-mind',
    deleteAccountDialogContent: 'delete-account-dialog-content',
    deleteAccountRefusedDialogContent: 'delete-account-refused-dialog-content',
    deleteAccountSuccessfulInformativeText:
      'delete-account-successful-informative-text',
    cancel: 'cancel',
    errorDeletingAccount: 'error-deleting-account',
    deleteAccountRequest: 'delete-account-request-button',
  };
  formGroup = new FormGroup({
    emailAddress: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  programEvaluationData: TProgramEvaluationData = {
    feedback: '',
    programProblem: '',
    recommendLevel: 0,
  };

  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    private readonly dialogService: DialogService,
    private readonly router: Router,
    private readonly snackBarService: SnackBarService,
    private readonly authenticatedUserService: AuthenticatedUserService,
    private readonly userService: UserService
  ) {}

  /**
   * on init
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.text);
  }

  /**
   * retrieves email address from form group
   */
  get emailAddressControl() {
    return this.formGroup.controls['emailAddress'];
  }

  /**
   * retrieves password control from form group
   */
  get passwordControl() {
    return this.formGroup.controls['password'];
  }

  /**
   * Opens delete account confirmation dialog
   */
  openDeleteAccountDialog() {
    // TODO: integrate with backend and check if this account can be deleted
    this.dialogService.openDialog(
      {
        title: this.text.deleteAccount,
        content: this.text.deleteAccountDialogContent,
        successButtonText: this.text.deleteAccount,
        failButtonText: this.text.cancel,
      },
      () => {
        this.deleteAccount();
      }
    );
  }

  /**
   * Actually disables representative admin account
   */
  deleteAccount() {
    const email = this.formGroup.value.emailAddress;
    const password = this.formGroup.value.password;
    const loginRequestDTO = new LoginRequestDTO(email!, password!);

    this.userService.disableRepresentative(loginRequestDTO).subscribe({
      error: () => {
        this.snackBarService.error(this.text.errorDeletingAccount);
      },
      complete: () => {
        this.authenticatedUserService.representativeDeleted = true;
        this.router.navigate([RoutesKeys.ACCOUNT_DELETED]);
      },
    });
  }

  /**
   * What text to show for delete account button
   * @return {string}
   */
  deleteAccountButtonText(): string {
    if (this.authenticatedUserService.isAdmin()) {
      return this.text.deleteAccountRequest;
    } else {
      return this.text.deleteMyAccount;
    }
  }
}
